import { GenericResponse, SimpleResponse } from "./genericResponse.model";

export interface Document {
  documentId: number;
  bytes: any;
  document: string;
  documentName: string;
  documentTypeIcon: string;
  documentType: number;
  ownerID: number;
  cLPUserID: number;
  cLPCompanyID: number;
  documentCategory: number;
  documentLength: number;
  isShared: boolean;
  isSelected: boolean;
  dtCreated: Date;
  userName: string;
  userDisplayToolTip: string;
}

export interface DocumentResponse extends GenericResponse {
  documents: Document[];
  fileSizeLimit: number;
  maxFiles: number;
}

export interface DocumentListResponse extends SimpleResponse {
  documents: Document[];
  maxFileSize: string;
}
